import { DecimalPipe } from '@angular/common';
import { StudentCoursesItem } from '../../models/BC_courses';
import { AppService } from '../../services/app.service';

export class Helpers {
    static canAddProgram(program: StudentCoursesItem): boolean {
        return program.IsAvailable;
    }

    static canRemoveProgram(program: StudentCoursesItem): boolean {
        return program.Application_statuss_code == 866560002 && program.CanWithdraw;
    }

    static getPointSummary(app: AppService, decimalPipe: DecimalPipe, data: { block: 'B' | 'C', plan: number, actual: number }[]): string {
        const template = app.translate('BC_courses_blockPointInfo');

        const ects = (points?: number) => {
            return decimalPipe.transform((points || 0) * 1.5, '1.0-2');
        };

        return ['B', 'C'].map(t => {
            const ps = data.find(n => n.block == t);
            return template
                .replace('{{block}}', t)
                .replace('{{plan}}', ps?.plan || 0)
                .replace('{{plan_ects}}', ects(ps?.plan))
                .replace('{{actual}}', ps?.actual || 0)
                .replace('{{actual_ects}}', ects(ps?.actual));
        }).join('<br>');
    }
}
